<template>
  <div class="groupsFiltersComp">

    <div class="div_filter">
      <label class="label_title label_filter" for="">Название группы</label>
      <multiselect-comp
        ref="names"
        :options="filters.names"
      />
    </div>

    <div class="div_filter">
      <label class="label_title label_filter" for="">ID владельца</label>
      <multiselect-comp
        ref="dealersId"
        :options="filters.dealersId"
      />
    </div>

    <div class="div_filter">
      <label class="label_title label_filter" for="">Имя владельца</label>
      <multiselect-comp
        ref="dealersName"
        :options="filters.dealersName"
      />
    </div>

    <div class="div_btns">
      <button-comp :classBtn="'btn_orange_min'" :textBtn="'Применить'" :clickBtn="filtering"/>
      <button-comp :classBtn="'btn_orange_min'" :textBtn="'Сбросить'" :clickBtn="reset"/>
      <button-comp :classBtn="'btn_orange_min'" :textBtn="'Назад'" :clickBtn="returnTbl"/>
    </div>

  </div>
</template>

<script>
export default {
  name: 'groupsFiltersComp',
  props: {
    showSliders: { type: Boolean, default: () => true }
  },
  data: function () {
    return {
      moduleName: 'groups',
      showMin: true
    }
  },
  beforeCreate () {
  },
  created: async function () {
  },
  components: {
  },
  computed: {
    filters: function () { return this.$store.getters[`${this.moduleName}/getFilters`] },
    filtersQuery: function () { return this.$store.getters[`${this.moduleName}/getFiltersQuery`] }
  },
  methods: {
    filtering () {
      let filters = {}
      filters.names = this.$refs.names.value
      filters.dealersId = this.$refs.dealersId.value
      filters.dealersName = this.$refs.dealersName.value
      this.$store.commit(`${this.moduleName}/setFiltersQuery`, filters)
      this.$store.commit(`${this.moduleName}/setShowFilters`, false)
      if (filters.names.length || filters.dealersId.length || filters.dealersName.length) this.$store.commit(`${this.moduleName}/setIsFilter`, true)
    },
    reset () {
      this.$refs.names.value = []
      this.$refs.dealersId.value = []
      this.$refs.dealersName.value = []
      this.$store.dispatch(`${this.moduleName}/getFilters`, {})
      this.$store.commit(`${this.moduleName}/resetFiltersQuery`)
      this.$store.commit(`${this.moduleName}/setIsFilter`, false)
    },
    returnTbl () {
      this.$store.commit(`${this.moduleName}/setShowFilters`, false)
    }
  }
}
</script>

<style scoped lang="scss">
.groupsFiltersComp {
  width: 350px;
  margin: 32px auto 32px auto;
}
.div_filter {
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr;
  margin-bottom: 25px;
}
.label_filter {
  margin-bottom: 25px;
}
.div_btns {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr 1fr;
}

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
  .groupsFiltersComp{
    width: calc(100% - 32px);
  }
}
@media screen and (max-width: 320px){
  .groupsFiltersComp label{
    margin: 0 0 10px 0;
  }
  .groupsFiltersComp input{
    margin: 0 0 20px 0;
  }
  .groupsFiltersComp button{
    margin: 12px 0 0 0;
  }
}
</style>
